<template>
  <div class="work_time">
    <head-top head-title="工时统计" go-back="true"></head-top>
    <div class="time_box">
      <div class="search_part">
        <div class="box_input">
          <img src="../images/btn_search@2x.png" alt="">
          <input type="text" @keyup.enter="searchName"  @input="searchName" v-model="keyword" placeholder="搜索姓名">
        </div>
      </div>
      <div class="tobe_list">
          <div class="box_single" v-for="(item, index) in workList" :key="index">
            <div class="basics">
              <div class="name_clock">
                <div class="name">姓名：<span>{{item.name}}</span></div>
                <div class="clock" @click="$router.push('/my/PunchRecord/'+ item.id)">打卡记录</div>
              </div>
              <div class="bas_li"><span>手机号：</span>{{item.phone}}</div>
              <div class="bas_time">
                <span>选择工时：</span>
                <input type="text" placeholder="请选择工时" v-model="item.label">
                <div class="time_c" @click="choiceTime(index)">
                  <img src="../../home/images/fanhui1@2x.png" alt="">
                </div>
              </div>
              <div class="bas_time">
                <span>工作时长：</span>
                <input type="text" placeholder="请输入工作时长" v-model="item.work_hours">
              </div>
              <div class="bas_time">
                <span>备注：</span>
                <input type="text" placeholder="请输入备注" v-if="item.remark" v-model="item.text=item.remark" @input="inputFn(index,$event)">
                <input type="text" placeholder="请输入备注" v-else v-model="item.remark" @input="inputFn(index,$event)">
              </div>
              <div class="btn_part">
                <div class="time_left">{{item.updated_at}}</div>
                <div class="btn" @click="keepData(item.id, item.work_hours, item.remark)">保存</div>
              </div>
            </div>
        </div>
      </div>
      <!--工作时长-->
      <mt-popup
        v-model="timePopup"
        position="bottom" class="time_popup">
        <div class="time_picker">
          <mt-picker :slots="dateSlots" ref="picker1" :show-toolbar="true" value-key="label">
            <span @click="handleCache()" class="btn btn_cancel">取消</span>
            <span @click="handleConfirm()" class="btn btn_sure">确定</span>
          </mt-picker>
        </div>
      </mt-popup>
      <!--暂无数据-->
      <div class="default1" v-show="noResult">
        <p>抱歉！暂无数据</p>
      </div>
    </div>
  </div>
</template>

<script>
  import headTop from '../../../components/header/Header'
  import {Toast, Indicator} from 'mint-ui'
  import {workTimeList, keepTime} from '../../../api/my'

  export default {
    name: 'WorkTime',
    data () {
      return {
        workList: [],
        timeArr: [],
        timePopup: false,
        time: '',
        timeId: '',
        keyword: '',
        currentTags: {},
        noResult: false,
        index: ''
      }
    },
    created () {
      this._workTimeList()
    },
    computed: {
      // picker中的数据是请求获取时，需要在computed里渲染，在methods里无法正常渲染会出现空白
      dateSlots () {
        // this.data1 = [{text: '全天班', value: '9.5'}, {text: '半天班', value: '5.5'}, {text: '其他', value: '0'}]
        this.data1 = this.timeArr
        let slots = [
          {
            flex: 1,
            values: this.data1,
            className: 'slot1',
            textAlign: 'center'
          }
        ]
        return slots
      }
    },
    methods: {
      // 搜索
      searchName() {
        Indicator.open({
          text: '..搜索中..',
          spinnerType: 'fading-circle'
        })
        workTimeList(this.keyword).then(res => {
          // console.log(res)
          if (res.code === 200) {
            Indicator.close()
            this.workList = res.data.data
            // console.log(this.data)
            if (this.workList.length === 0) {
              this.noResult = true
            } else {
              this.noResult = false
            }
          }
        })
      },
      // 列表
      _workTimeList() {
        Indicator.open({
          text: '..加载中..',
          spinnerType: 'fading-circle'
        })
        workTimeList().then(res => {
          // console.log(res)
          if (res.code === 200) {
            Indicator.close()
            this.workList = res.data.data
            this.timeArr = res.data.option
            if (this.workList.length === 0) {
              this.noResult = true
            } else {
              this.noResult = false
            }
          }
          if (res.code === 400) {
            Indicator.close()
          }
        })
      },
      // 工作时长弹窗
      choiceTime(index) {
        this.timePopup = true
        this.index = index
      },
      // 确认时长
      handleConfirm () {
        var object1 = this.$refs.picker1.getValues()[0]
        const newArr = this.workList[this.index]
        newArr.label = object1.label
        newArr.work_hours = object1.value
        this.$set(this.workList, this.index, newArr)
        this.timePopup = false
      },
      handleCache() {
        this.timePopup = false
      },
      // 备注
      inputFn (i, e) {
        this.workList[i].remark = e.target.value
      },
      keepData(id, time, text) {
        console.log(1)
        if (time <= 0) {
          Toast({
            message: '工时不能小于等于0小时！',
            position: 'middle',
            duration: 2000
          })
          return
        }
        Indicator.open({
          text: '..保存中..',
          spinnerType: 'fading-circle'
        })
        keepTime(id, time, text).then(res => {
          console.log(res)
          if (res.code === 200) {
            Indicator.close()
            Toast({
              message: res.data,
              position: 'middle',
              duration: 2000
            })
            this._workTimeList()
          }
          if (res.code === 400) {
            Indicator.close()
            Toast({
              message: res.error,
              position: 'middle',
              duration: 2000
            })
            return
          }
        })
      }
    },
    components: {
      headTop
    }
  }
</script>

<style lang="scss" scoped>
.work_time{
  padding-top: 60px;
  .time_box{
    width: 100%;
    .search_part{
      padding: 10px;
      .box_input{
        display: inline-flex;
        align-items: center;
        background: white;
        border: 1px solid #0C7AD9;
        border-radius: 20px;
        /*padding: 5px;*/
        width: 100%;
        img{
          width: 20px;
          height: 20px;
          margin:0 10px;
        }
        input{
          background: white;
          border: none;
          outline: none;
          padding: 10px 0;
          font-size: 15px;
          color: #999999;
        }
      }
    }
    .tobe_list{
      margin-top: 20px;
      .box_single{
          padding: 10px;
          .basics{
            border-radius: 10px;
            border: 1px solid #f2f2f2;
            box-shadow: 0 0 5px rgba(0,0,0,0.1);
            padding: 15px 10px;
            margin-top: 10px;
            .name_clock{
              display: inline-flex;
              align-items: center;
              justify-content: space-between;
              width: 100%;
              font-size: 15px;
              .name{
                color: #333333;
                span{
                  color: #666666;
                }
              }
              .clock{
                color: #0C7AD9;
              }
            }
            .bas_li{
              font-size: 15px;
              color: #666666;
              margin-top: 20px;
              margin-bottom: 10px;
              span{
                color: #333333;
              }
            }
            .bas_time{
              font-size: 15px;
              display: inline-flex;
              align-items: center;
              span{
                color: #333333;
              }
              input{
                background: white;
                outline: none;
                border: none;
                font-size: 15px;
                padding: 10px 0;
                color: #666666;
              }
              .time_c{
                width: 60px;
                padding: 5px 0;
                text-align: right;
                float: right;
                img{
                  width: 8px;
                  height: 15px;
                  transform: rotate(90deg);
                }
              }

            }
            .btn_part{
              display: inline-flex;
              align-items: center;
              justify-content: space-between;
              width: 100%;
              margin-top: 10px;
              .time_left{
                font-size: 15px;
                color: #999999;
              }
              .btn{
                font-size: 16px;
                color: #0C7AD9;
                border-radius: 50px;
                width: 45%;
                padding: 10px 0;
                text-align: center;
                border: 1px solid #0C7AD9;
              }
            }
          }

        }
    }
    .time_popup{
      width: 100%;
      .time_picker{
        .btn{
          font-size: 16px;
          height: 40px;
          line-height: 40px;
          padding: 0 20px;
          display: inline-block;
        }
        .btn_cancel{
          color: #666666;
        }
        .btn_sure{
          color: #0C7AD9;
          float: right;
        }
      }
    }
    .default1 {
      width: 100%;
      flex: 1;
      display: inline-flex;
      padding-top: 100px;
      justify-content: center;
      align-items: center;
      background: url("../../../assets/default.png") no-repeat;
      background-size: 100px 100px;
      background-position: center;
      padding-bottom: 140px;
      p {
        font-size: 15px;
        color: #0b7ad9;
        margin-top: 180px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/my/runBuild/WorkTime.vue